import { GET_NDHM_HOST } from "../../constants/env";
import fetch from "../../fetch-client";
import { AxonGenericApiResponse } from "../../types/axon";

export default async function postHprVerifyAadhaarOtp({
  txn_id,
  otp,
}: {
  txn_id: string;
  otp: string;
}): Promise<AxonGenericApiResponse<{ txn_id: string; mobile_num: string }>> {
  try {
    const NDHM_HOST = GET_NDHM_HOST();
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const body = JSON.stringify({ txn_id, otp });
    const requestOptions: RequestInit = {
      method: "POST",
      headers: myHeaders,
      redirect: "follow",
      body,
      mode: "cors",
      credentials: "include",
    };
    const response = await fetch(
      `${NDHM_HOST}/abdm/nhpr/v1/hpr/aadhaar/verify`,
      requestOptions
    );
    return await response.json();
  } catch (error) {
    return { success: false };
  }
}
